import { render, staticRenderFns } from "./ModalDeleteCompany.vue?vue&type=template&id=7e723b31&scoped=true&"
import script from "./ModalDeleteCompany.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e723b31",
  null
  
)

export default component.exports